// src/features/system/edge-tasks/hooks/useEdgeTasks.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchEdgeTasks,
  dispatchEdgeTask,
  type EdgeTaskListResponse,
  type DispatchEdgeTaskParams,
} from '../api/edgeTasksApi';

const QUERY_KEY = ['system', 'edge-tasks'];

export function useEdgeTasks() {
  const qc = useQueryClient();

  const list = useQuery<EdgeTaskListResponse, Error>({
    queryKey: QUERY_KEY,
    queryFn: () => fetchEdgeTasks(),
    staleTime: 10_000,
    refetchInterval: 15_000,
  });

  const dispatch = useMutation({
    mutationFn: (p: DispatchEdgeTaskParams) => dispatchEdgeTask(p),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });

  return { ...list, dispatch };
}
